<div class="row mb-3">
  <div class="col-auto">
    <h1 class="h3 mt-3 mb-0">Claims List</h1>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="mb-4">
            <div class="d-flex align-items-center">
            <div class="d-inline-block mb-3 me-4">
              <div class="ps-1">
                <small>Status</small>
              </div>
              <angular2-multiselect
                [data]="claimStatusMultiselect"
                [(ngModel)]="claimStatusSelectedItems"
                [settings]="claimStatusMultiselectSettings"
                (onClose)="onClaimStatusMultiselectClose();"
              >
              </angular2-multiselect>
            </div>
            <div class="form-check form-switch d-inline-block mt-2">
              <input 
                id="showClaimsForAdjuster" 
                class="form-check-input" 
                type="checkbox"
                (change)="claimsFilterChanged()"
                [(ngModel)]="showSelfAssignedClaimsOnly"
                [value]="true"
              >
              <label class="form-check-label" for="showClaimsForAdjuster">Show My Unprocessed Claims</label>
            </div>
          </div>
          <hr class="mt-0" />
        </div>
        <div class="table-responsive position-relative" *ngIf="!errorOccurred">
          <table datatable #claimsDataTable [dtOptions]="dtOptions" class="table table-sm table-striped table-hover lh-md w-100"></table>
          <div class="position-absolute top-0 start-0 w-100 h-100" [ngClass]="{'d-none': !isLoading}">
            <div class="w-100 h-100 bg-white opacity-65"></div>
            <div class="position-absolute top-0 start-50 translate-middle-x">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="errorOccurred">
          <div class="alert alert-danger alert-outline-coloured mb-0" role="alert">
            <div class="alert-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>
                <line x1="12" y1="8" x2="12" y2="12"></line>
                <line x1="12" y1="16" x2="12.01" y2="16"></line>
              </svg>
            </div>
            <div class="alert-message">
              <p class="mb-2"><strong>Unable to retrieve claims list.</strong> An error occurred while trying to obtain the list of claims.</p>
              <button class="btn btn-outline-secondary" (click)="errorOccurred = false;">Try Again</button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
